"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Logo = require("../Logo");

var _Logo2 = _interopRequireDefault(_Logo);

var _TopHeaderProfile = require("../TopHeaderProfile");

var _TopHeaderProfile2 = _interopRequireDefault(_TopHeaderProfile);

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const StyledWrapper = _styledComponents2.default.div.withConfig({
  displayName: "TopHeader__StyledWrapper",
  componentId: "jpifve-0"
})(["background:", ";width:100%;"], _styles.colors.topHeaderBackground);

const StyledContent = _styledComponents2.default.div.withConfig({
  displayName: "TopHeader__StyledContent",
  componentId: "jpifve-1"
})(["align-items:center;display:flex;"]);

const StyledLogoButton = _styledComponents2.default.button.withConfig({
  displayName: "TopHeader__StyledLogoButton",
  componentId: "jpifve-2"
})(["background-color:transparent;outline:none;padding:17px 0px;border:none;color:white;padding-left:32px;svg{color:red;padding:0px 12px;}"]);

const StyledNameButton = _styledComponents2.default.div.withConfig({
  displayName: "TopHeader__StyledNameButton",
  componentId: "jpifve-3"
})(["background-color:transparent;border:0;color:", ";font-family:", ";font-size:12px;font-weight:500;outline:none;padding:0;padding-left:12px;padding-bottom:4px;line-height:16px;border-left:1px solid rgb(220,233,255);> span{margin-left:4px;color:#ffffff;font-size:16px;font-weight:200;text-align:left;letter-spacing:0px;}"], _styles.colors.white, _styles.fontFamily1);

const NameContainer = _styledComponents2.default.div.withConfig({
  displayName: "TopHeader__NameContainer",
  componentId: "jpifve-4"
})(["display:flex;flex-direction:column;"]);

const TopRow = _styledComponents2.default.div.withConfig({
  displayName: "TopHeader__TopRow",
  componentId: "jpifve-5"
})(["font-weight:500;"]);

const BottomRow = _styledComponents2.default.div.withConfig({
  displayName: "TopHeader__BottomRow",
  componentId: "jpifve-6"
})(["font-weight:300;"]);

const StyledChildrenWrapper = _styledComponents2.default.div.withConfig({
  displayName: "TopHeader__StyledChildrenWrapper",
  componentId: "jpifve-7"
})(["margin-right:24px;height:59px;display:flex;flex-grow:1;justify-content:flex-end;"]);

const TopHeader = (_ref) => {
  let {
    children,
    logoColor,
    title,
    onLogoClick = Function.prototype,
    onTitleClick = Function.prototype,
    version
  } = _ref,
      props = _objectWithoutProperties(_ref, ["children", "logoColor", "title", "onLogoClick", "onTitleClick", "version"]);

  return _react2.default.createElement(
    StyledWrapper,
    props,
    _react2.default.createElement(
      StyledContent,
      null,
      _react2.default.createElement(
        StyledLogoButton,
        { onClick: onLogoClick },
        _react2.default.createElement(_Logo2.default, { size: 24, color: logoColor })
      ),
      _react2.default.createElement(
        StyledNameButton,
        { onClick: onTitleClick },
        _react2.default.createElement(
          NameContainer,
          null,
          _react2.default.createElement(
            TopRow,
            null,
            title.toUpperCase().split(" ")[0]
          ),
          _react2.default.createElement(
            BottomRow,
            null,
            title.toUpperCase().split(" ")[1],
            _react2.default.createElement(
              "span",
              null,
              " ",
              version
            )
          )
        )
      ),
      _react2.default.createElement(
        StyledChildrenWrapper,
        null,
        children
      )
    )
  );
};

TopHeader.propTypes = {
  /**
   * Note: all children are `flex-end`
   */
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  logoColor: _propTypes2.default.string,
  title: _propTypes2.default.string,
  onLogoClick: _propTypes2.default.func,
  onTitleClick: _propTypes2.default.func,
  version: _propTypes2.default.string
};

TopHeader.Profile = _TopHeaderProfile2.default;

exports.default = TopHeader;